import { Colors, ColorsHexa } from '@/components/common';

const proposalDocumentStatus = Object.freeze({
  Denied: 1,
  Approved: 2,
  Submitted: 3,
  Pending: 5,
  RequestReplacement: 6,
});

export const resolveColor = (statusId) => {
  switch (statusId) {
    case proposalDocumentStatus.Approved:
      return Colors.GREEN_LIGHT;
    case proposalDocumentStatus.Denied:
      return Colors.BROWN;
    case proposalDocumentStatus.Pending:
      return Colors.PINK;
    case proposalDocumentStatus.Submitted:
      return Colors.YELLOW;
    case proposalDocumentStatus.RequestReplacement:
      return Colors.PURPLE_LIGHT;
    default:
      return null;
  }
};

export const resolveColorHexa = (statusId) => {
  switch (statusId) {
    case proposalDocumentStatus.Approved:
      return ColorsHexa.GREEN_LIGHT;
    case proposalDocumentStatus.Denied:
      return ColorsHexa.BROWN;
    case proposalDocumentStatus.Pending:
      return ColorsHexa.PINK;
    case proposalDocumentStatus.Submitted:
      return ColorsHexa.YELLOW;
    case proposalDocumentStatus.RequestReplacement:
      return ColorsHexa.PURPLE_LIGHT;
    default:
      return null;
  }
};

export default proposalDocumentStatus;
